<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-0">Determine which of the following processes are spontaneous:</p>

      <div v-for="option in options" :key="option.value">
        <v-checkbox
          v-model="inputs.input1"
          class="d-inline-block pl-10"
          :value="option.value"
          :dense="true"
          hide-details="true"
          :ripple="false"
          :label="option.text"
        >
          <template #label>
            <stemble-latex :content="`$\\text{${option.text}}$`" />
          </template>
        </v-checkbox>
      </div>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question292',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        input1: [],
      },
      options: [
        {
          text: 'Liquid water freezing at a temperature \\textbf{below} its freezing point',
          value: 'a',
        },
        {
          text: 'Liquid water freezing at a temperature \\textbf{above} its freezing point',
          value: 'b',
        },
        {text: 'The combustion of gasoline', value: 'c'},
        {text: 'A ball thrown into the air', value: 'd'},
        {text: 'A raindrop falling to the ground', value: 'e'},
        {text: 'Iron rusting in a moist atmosphere', value: 'f'},
      ],
    };
  },
};
</script>
